import { render, staticRenderFns } from "./MailMagazine.vue?vue&type=template&id=c594c07a&scoped=true&"
import script from "./MailMagazine.vue?vue&type=script&lang=js&"
export * from "./MailMagazine.vue?vue&type=script&lang=js&"
import style0 from "./MailMagazine.vue?vue&type=style&index=0&id=c594c07a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c594c07a",
  null
  
)

export default component.exports